import MSCombi2D from './mscombi2d';
import ColumnDataset from '../_internal/datasets/column';
import LineDataset from '../_internal/datasets/line';
import SplineLineDataset from '../_internal/datasets/msspline';
import CartesianStackGroup from '../_internal/datasets/groups/cartesian.stack';
let UNDEFINED;

class StackedColumn2DLine extends MSCombi2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'StackedColumn2DLine';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'StackedColumn2DLine';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Stacked Column and Line Chart';
    config.defaultDatasetType = 'column';
    config.isstacked = true;
    config.stack100percent = 0;
    config.enablemousetracking = true;
  }
  /**
   * This method return the dataset definations for this charts
   * @param  {string} name type of dataset class
   * @return {Object}      dataset class
   */
  getDSdef (name) {
    if (name === 'spline') {
      return SplineLineDataset;
    } else if (name === 'line') {
      return LineDataset;
    }
    return ColumnDataset;
  }
  /**
   * This method return the dataset-group definations for this charts
   * @param  {string} name is type of dataset group
   * @return {Object} <dataset group class>     dataset group class
   */
  getDSGroupdef (name) {
    return name === 'column' ? CartesianStackGroup : UNDEFINED;
  }
  /**
   * function to return dataset type applicable for this chart
   * @param   {string}  name  dataset type
   * @return  {string}        dataset type applicable for this chart
   */
  getDSType (name = '') {
    if (name.toLowerCase() === 'line') {
      return 'line';
    }
    return 'column';
  }
}
export default StackedColumn2DLine;
